import useGnbCount from '@hooks/useGnbCount';
import React from 'react';
import BottomNavPresenter from './BottomNavPresenter';

const BottomNavContainer: React.FC = () => {
  const { gnbCount } = useGnbCount();

  return <BottomNavPresenter gnbCount={gnbCount} />;
};

export default BottomNavContainer;
